export default __webpack_public_path__ + "static/media/Bar.e0052c73.jpg";